import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isNativePlatform } from '../lib/nativeSocialAuth';
import KalotechCredit from './KalotechCredit';

const linkStyle = { fontSize: '0.82rem', color: 'var(--text-muted)', textDecoration: 'none' };

export default function Footer() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const hide = (to) => pathname === to;

  // Native apps don't repeat a marketing-site-style footer on every screen -- the bottom
  // tab bar already occupies that real estate, and there's no room for both. The
  // account/settings screen carries the equivalent legal/support links instead
  // (see Settings.js's "Legal & Support" section), matching common native app convention.
  if (isNativePlatform()) return null;

  return (
    <footer className="site-footer">
      <nav className="site-footer-links" aria-label="Footer">
        <a href="/blog/" style={linkStyle}>Blog</a>
        {!hide('/about') && <Link to="/about" style={linkStyle}>About</Link>}
        {!hide('/help') && <Link to="/help" style={linkStyle}>Help</Link>}
        {/* Support opens the AI chat, which only mounts for authenticated users —
            hide it when logged out (would be a no-op; Help covers self-serve). */}
        {isAuthenticated && (
          <button
            onClick={() => window.dispatchEvent(new CustomEvent('open-chat'))}
            style={{ ...linkStyle, fontFamily: 'inherit', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >Support</button>
        )}
        {!hide('/pricing') && <Link to="/pricing" style={linkStyle}>Pricing</Link>}
        {!hide('/privacy') && <Link to="/privacy" style={linkStyle}>Privacy Policy</Link>}
        {!hide('/terms') && <Link to="/terms" style={linkStyle}>Terms of Service</Link>}
        {!hide('/automation-disclosure') && <Link to="/automation-disclosure" style={linkStyle}>Automation Risk Disclosure</Link>}
      </nav>
      <span className="site-footer-copy"><KalotechCredit /></span>
    </footer>
  );
}
